
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";
import { BCarousel } from "bootstrap-vue";
import CiButton from "@components/base/button.vue";
import RegistrationMixin from "@components/events/registration.mixin";
import CiRegistrationButton from "@components/events/registration-button.vue";
import { useRegion } from "@composables/region";
import { dateService } from "@services/date.service";

@Component({
  name: "ci-social-event-tile",
  components: { "ci-button": CiButton, "ci-registration-button": CiRegistrationButton },
})
export default class extends Mixins(RegistrationMixin) {
  @Ref("company-logos-list") public companyLogosCarousel!: BCarousel;
  @Prop({}) public dataEvent!: Events.Event;
  @Prop({ required: false }) public context!: string;
  @Prop({ default: "full" }) public variant!: string;
  @Prop({ default: false }) public withBorder!: boolean;
  @Prop({ default: () => ({}) }) public additionalTracking!: Nullable<{ [id: string]: string }>;

  private styleVariation: Record<string, Record<string, string>> = {
    light: {
      main: "",
      buttonLeft: "d-flex",
      buttonRight: "d-none",
      description: "",
    },
    full: {
      main: "col-sm-8 col-md-6 col-lg-7",
      buttonLeft: "d-flex d-xxl-none",
      buttonRight: "col-md-3 col-lg-2 d-none d-xxl-flex",
      description: "d-md-block",
    },
    start_page: {
      main: "col-sm-8 col-md-6 col-lg-12",
      buttonLeft: "d-flex",
      buttonRight: "d-none",
      description: "d-md-block",
    },
  };
  private region = useRegion();

  get contextSize(): Record<string, string> {
    return this.styleVariation[this.variant];
  }

  get companyProfiles(): Events.CompanyProfile[] {
    return (
      this.event?.company_profiles?.filter((profile) =>
        profile.available_regions?.find((region) => region === this.region.currentRegionCode())
      ) || []
    );
  }

  get description(): string | undefined {
    return this.event?.description ? this.event.description.replace(/\n/g, "<br/>") : "";
  }

  get eventType(): TranslateResult {
    if (!this.event || this.event.event_date === "") return "";

    return this.event.webinar
      ? this.$t("ui.components.social_events.tile.webinar")
      : this.$t("ui.components.social_events.tile.event");
  }

  get eventDateParts(): Record<string, ExplicitAny> {
    if (!this.event || this.event.event_date === "") return {};

    const day: string = dateService.format("dd", this.event.event_date);
    const month: string = dateService.format("MMMM", this.event.event_date);
    const dayTime: string = dateService.format("HH:mm", this.event.event_date);

    return { day, month, dayTime };
  }

  get activeEvent(): boolean {
    const dateStr = this.event?.event_end_date || this.event?.event_date;
    const eventEndDate = dateStr ? new Date(dateStr) : new Date();

    return eventEndDate > new Date();
  }

  get directSignup(): boolean {
    return !!this.event?.external_event && !this.event?.disable_direct_signup;
  }

  get registrationContext(): string | undefined {
    return this.additionalTracking ? this.additionalTracking.sourceName : undefined;
  }

  @Watch("dataEvent")
  onDataEventChanged(newEvent: Events.Event): void {
    this.event = {
      ...newEvent,
      participationState: "loading",
    };
    this.updateParticipation();
  }

  protected beforeMount(): void {
    this.event = {
      ...this.dataEvent,
      participationState: "loading",
    };
    this.updateParticipation();
  }

  protected mounted(): void {
    if (this.companyProfiles.length > 1) {
      const randomInt = Math.floor(Math.random() * this.companyProfiles.length);
      if (this.companyLogosCarousel) this.companyLogosCarousel.setSlide(randomInt);
    }
  }

  private async updateParticipation(): Promise<void> {
    if (this.event?.id) {
      this.participationCallFailed = false;

      await this.getUserParticipation(this.event).then((response) => {
        this.event = response;
      });
    }
  }
}
